// Meta (Facebook) Pixel event helpers.
//
// The base pixel + PageView are injected in index.html (Web dataset
// "Ad Astronaut Web", ID 2119514558638632). These fns fire conversion events
// from the app funnel so ad campaigns can optimize toward signups/trials
// instead of raw clicks:
//   - CompleteRegistration → account created (SignUpPage)
//   - StartTrial           → trial checkout completed (checkout/success)
//
// window.fbq is added by the base pixel snippet. trackPixel() is guarded so it
// silently no-ops if the pixel failed to load or an ad blocker stripped it —
// callers never need to null-check, and analytics can never break the app.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/** Fire a standard Meta Pixel event (e.g. 'CompleteRegistration', 'StartTrial').
 *  Safe to call anywhere — no-ops when the pixel isn't available. */
export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
    if (params) window.fbq('track', event, params);
    else window.fbq('track', event);
  } catch {
    // Analytics must never throw into the app.
  }
}
